import React, { Component } from 'react';

import CommunityUserProfile from './CommunityUserProfile';

class MainUserProfileContainerView extends Component {

    render() {
        return (
            <CommunityUserProfile personId={parseInt(this.props.match.params.id, 10)}
                uniqueName={this.props.match.params.unique_name}/>
        );
    }
}

export default MainUserProfileContainerView;
